import { useNavigate } from 'react-router-dom'
import { ChevronRightIcon } from '@heroicons/react/20/solid'
import { GetDateTimeDisplay } from 'functions/textUtils'
import StrengthIcon from 'media/icons/strength.png'
import MobilityIcon from 'media/icons/mobility.png'
import moment from 'moment'

export default function WorkoutV5ListItem({ workout }) {

    const navigate = useNavigate()

    const workoutName = workout.name || ''
    const completedTimestamp = workout.completedTimestamp || workout.timestamp
    const hasValidCompletedTimestamp = moment.utc(completedTimestamp).local().isValid()

    const GetWorkoutIcon = () => {
        const workoutConfigTag = (workout.workoutConfigTag || '').toLowerCase()

        if (workoutConfigTag.includes('mobility') || workoutName.toLowerCase().includes('mobility')) {
            return MobilityIcon
        }

        return StrengthIcon
    }

    return (
        <div 
            className="w-full flex items-center px-6 py-4 gap-x-6 hover:bg-gray-50 cursor-pointer"
            onClick={() => navigate(`/workout/${workout.id}/summary`)}
        >
            <div className="h-12 w-12 bg-orange-400 rounded-full items-center">
                <img src={GetWorkoutIcon()} alt="Workout Icon" className="h-6 m-3 invert" />
            </div>

            <div className="flex-grow">
                <p className="font-semibold">{workoutName}</p>
                <p className="text-sm">{workout.firstName} {workout.lastName}</p>
            </div>

            {hasValidCompletedTimestamp && (
                <p className="w-64 text-left text-sm">{GetDateTimeDisplay(completedTimestamp)}</p>
            )}

            {!hasValidCompletedTimestamp && (
                <p className="w-64 text-left text-sm">Incomplete</p>
            )}

            <ChevronRightIcon className="text-gray-400 h-8" />
        </div>
    )
}
